import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { getLabel } from './loading-progress';

export function SourceIcon({ source }) {
    return (
        <img alt='icon button' src={source} style={{ width: 16, height: 16 }} />
    );
}

SourceIcon.propTypes = {
    source: PropTypes.string.isRequired
};

const PrimarySmallButton = withStyles(() => ({
    root: {
        color: '#ffffff',
        backgroundColor: '#237fc2',
        '&:hover': {
            backgroundColor: '#65a9db',
        },
        '&:active': {
            backgroundColor: '#1b669d',
        },
        '&:disabled': {
            color: '#ffffff',
            backgroundColor: '#a7cce7',
        },
        borderRadius: 10,
        padding: '5px 15px',
        height: 30
    },
    label: {
        fontSize: 9,
        fontFamily: 'UniviaPro-Bold',
        letterSpacing: 0.36,
        lineHeight: '11px',
        marginTop: 2
    },
    startIcon: {
        marginRight: 4,
        marginBottom: 4
    },
    endIcon: {
        marginLeft: 4,
        marginBottom: 4
    }
}))(Button);

const PrimaryMediumButton = withStyles(() => ({
    root: {
        color: '#ffffff',
        backgroundColor: '#237fc2',
        '&:hover': {
            backgroundColor: '#65a9db',
        },
        '&:active': {
            backgroundColor: '#1b669d',
        },
        '&:disabled': {
            color: '#ffffff',
            backgroundColor: '#a7cce7',
        },
        borderRadius: 10,
        padding: '7px 16px'
    },
    label: {
        fontSize: 11,
        fontFamily: 'UniviaPro-Bold',
        letterSpacing: 0.44,
        lineHeight: '11px',
    },
    startIcon: {
        marginRight: 8,
        marginBottom: 2
    },
    endIcon: {
        marginLeft: 8,
        marginBottom: 2
    }
}))(Button);

const SecondarySmallButton = withStyles(() => ({
    root: {
        borderRadius: 10,
        padding: '5px 15px',
        height: 30
    },
    label: {
        fontSize: 9,
        fontFamily: 'UniviaPro-Bold',
        letterSpacing: 0.36,
        lineHeight: '11px',
        marginTop: 2
    },
    startIcon: {
        marginRight: 4,
        marginBottom: 4
    },
    endIcon: {
        marginLeft: 4,
        marginBottom: 4
    }
}))(Button);

function CustomizeButton({ label, onClick, large, secondary, loading, ...props }) {
    if (!large) {
        if (secondary) {
            return <SecondarySmallButton variant='contained' color='secondary' {...props} size='small' onClick={onClick}>{getLabel(loading, label)}</SecondarySmallButton>
        }
        return (
            <Button size='small' variant='contained' color='primary' {...props} onClick={onClick}>{label}</Button>
        );
    }
    return <Button variant='contained' color='primary' {...props} onClick={onClick}>{label}</Button>
}


CustomizeButton.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    large: PropTypes.bool,
    secondary: PropTypes.bool,
    loading: PropTypes.bool
}

export default CustomizeButton;
